export default __webpack_public_path__ + "static/media/car_placeholder.d3783499.svg";